export enum TimeFramesQueryKey {
  Primary = 'time-frames',
}
